import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as Sentry from '@sentry/react';

import { useCurrentUser } from 'hooks';

import ErrorPage from './ErrorPage';

const useStyles = makeStyles({
  '@global body > .sentry-error-embed-wrapper': {
    zIndex: 10000,
  },
});

const ErrorBoundary: FC = ({ children }) => {
  const currentUser = useCurrentUser();
  const options = {
    user: {
      name: currentUser?.full_name,
      email: currentUser?.email_address,
    },
  };

  useStyles();

  return (
    <Sentry.ErrorBoundary fallback={ErrorPage} showDialog dialogOptions={options}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
